type DatedServiceRequest = {
    id?: string;
    submittedAt?: unknown;
    createdAt?: unknown;
    updatedAt?: unknown;
};

function timestamp(value: unknown): number {
    if (typeof value === 'string' || typeof value === 'number') {
        const parsed = new Date(value).getTime();
        return Number.isFinite(parsed) ? parsed : 0;
    }
    if (value instanceof Date)
        return value.getTime();
    if (value && typeof (value as any).toMillis === 'function')
        return Number((value as any).toMillis()) || 0;
    return 0;
}

export function serviceRequestDate(request: DatedServiceRequest): number {
    return timestamp(request.submittedAt) || timestamp(request.createdAt) || timestamp(request.updatedAt);
}

export function newestServiceRequests<T extends DatedServiceRequest>(requests: readonly T[]): T[] {
    return requests.map((request, index) => ({ request, index }))
        .sort((left, right) => serviceRequestDate(right.request) - serviceRequestDate(left.request) || left.index - right.index)
        .map(item => item.request);
}
